import React from "react";

/* Un écran qui plante ne laisse plus une page blanche (09.10.2026 : app installée qui ne
   montrait plus rien, sans aucune trace). L'erreur part au serveur (journaux Render :
   « DÉMARRAGE APP rendu »), et la personne peut réessayer ou remettre l'app à zéro
   (service worker et cache effacés — voir la garde de démarrage dans public/index.html). */
export default class GardeErreur extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidCatch(erreur, info) {
    const pile = String(info?.componentStack || "").trim().split("\n").slice(0, 4).join(" < ");
    window.signalerDemarrage?.("rendu", erreur?.message || String(erreur), pile);
  }

  render() {
    if (!this.state.erreur) return this.props.children;
    return (
      <div style={{ maxWidth: 420, margin: "0 auto", padding: "64px 24px", textAlign: "center" }}
        data-testid="garde-erreur">
        <div className="font-display" style={{ fontWeight: 700, fontSize: 22, marginBottom: 8 }}>1000 ARTS</div>
        <p style={{ color: "#5B6B7A", fontSize: 15, lineHeight: 1.5, margin: "0 0 24px" }}>
          Oups, cet écran n'a pas pu s'afficher. L'école est prévenue automatiquement.
        </p>
        <button className="btn-primary w-full justify-center" style={{ marginBottom: 10 }}
          onClick={() => window.location.reload()}>Réessayer</button>
        <button className="btn-ghost w-full justify-center"
          onClick={() => (window.remettreAppAZero ? window.remettreAppAZero() : window.location.reload())}>
          Remettre l'application à zéro
        </button>
      </div>
    );
  }
}
